export enum AcquisitionCronFrequencyEnum {
  S1 = "S1",
  S30 = "S30",
  M1 = "M1",
  M5 = "M5",
  M15 = "M15",
  H1 = "H1",
}
